<template>
    <div class="border rounded-lgr p-2.5 h-fit flex flex-col gap-2" data-testid="linked-profiles-card">
        <p class="whitespace-nowrap scaffold-body-small-medium flex items-center gap-2">Linked profiles</p>
        <HorizontalDivider class="my-1" />
        <div class="flex flex-col gap-3 mb-2">
            <p class="flex items-baseline gap-2">
                <span class="display-serif text-valence-grey-850" data-testid="linked-profiles-count">{{ linkedCount }}</span>
                <span class="scaffold-body-small text-valence-grey-750">{{ linkedCount === 1 ? "person linked" : "people linked" }}</span>
            </p>
            <p class="scaffold-body-small text-valence-grey-750">{{ description }}</p>
        </div>
        <BaseButton
            v-if="showHowToLink"
            theme="primary"
            size="sm"
            class="mt-auto flex gap-2 items-center justify-center animate-shadow-pulse"
            data-testid="how-to-link-button"
            @click="emit('how-to-link')">
            <i class="bi bi-play-circle text-base/none" aria-hidden="true"></i> How to link
        </BaseButton>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import HorizontalDivider from "~vue/components/HorizontalDivider.vue";
import { computed } from "vue";

const HOW_TO_LINK_MAX_LINKS = 3;

const { linkedCount } = defineProps<{ linkedCount: number }>();

const emit = defineEmits<{ "how-to-link": [] }>();

const showHowToLink = computed(() => linkedCount < HOW_TO_LINK_MAX_LINKS);

const description = computed(() =>
    linkedCount === 0 ? "Link a colleague's profile for more personalized coaching about working with them." : "Ask Nadia about a linked colleague for more personalized coaching.",
);
</script>
